import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=7b8bfb17&scoped=true&"
import script from "./ResourceDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDialog.vue?vue&type=style&index=0&id=7b8bfb17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bfb17",
  null
  
)

export default component.exports